import { type FC } from 'react'
import { HiUser } from 'react-icons/hi'
import { useAuth } from 'src/AuthContext'

const Avatar: FC<{ className?: string }> = ({ className }) => {
  const { userProfile } = useAuth()
  return (
    <>
      {userProfile?.avatar && (
        <img
          src={userProfile.avatar}
          alt={userProfile.displayName ?? ''}
          className={`rounded-full ${className ?? ''}`}
        />
      )}
      {!userProfile?.avatar && (
        <span
          className={`rounded-full border border-neutral-450 bg-black/20 flex items-center justify-center ${className ?? ''}`}
        >
          <HiUser className="w-5 h-5 text-purplegray-400" />
        </span>
      )}
    </>
  )
}

export default Avatar
